class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.currentTarget.dataset.popup;
        const popup = document.getElementById(id);
        const previewCart = event.currentTarget.closest('.previewCart');
        if (popup) popup.classList.add('show');
        if (previewCart) previewCart.classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* Cupom e frete: linha com botão redondo que desliza e abre o campo ao lado (igual ao
 * carrinho da Nutrii). Com o campo aberto, o botão aplica o que foi digitado e, vazio,
 * fecha; com cupom aplicado e campo fechado, vira um X que remove o cupom.
 * O estado aberto fica fora do HTML substituído pelo AJAX. */
(function initLinearCartTools() {
  if (window.diMangiareLinearCartToolsInit) return;

  window.diMangiareLinearCartToolsInit = true;
  window.diMangiareCartOpenTool = "";
  let shippingCloseTimer = null;

  function cancelShippingClose() {
    window.clearTimeout(shippingCloseTimer);
    shippingCloseTimer = null;
  }

  function scheduleShippingClose(tool, delay) {
    cancelShippingClose();
    shippingCloseTimer = window.setTimeout(() => {
      if (!tool.isConnected || !tool.classList.contains("is-open") ||
          !tool.querySelector(".shipping-option-radio:checked")) return;
      closeTool(tool);
      tool.querySelector("[data-dm-mobile-cart-tool-toggle]")?.focus();
    }, delay);
  }

  const fieldOf = (tool) =>
    tool.querySelector('[data-dm-mobile-cart-tool-panel] input:not([type="hidden"])');
  const appliedCodeOf = (tool) => {
    const component = tool.querySelector("cart-discount-component");
    if (!component || !tool.querySelector(".dm-mobile-cart-tool__action.is-code")) return "";
    return [...(component.appliedDiscounts || [])].pop() || "";
  };

  // Texto digitado e ainda não enviado: é o que faz o botão aplicar em vez de fechar.
  function isPending(tool) {
    const value = fieldOf(tool)?.value.trim() || "";
    return value !== "" && value !== (tool.dataset.submittedValue || "");
  }

  // Ícone e nome acessível do botão conforme o estado, reaproveitando os textos que o
  // tema já tem (botão de envio do formulário e remoção de cupom).
  function syncToggle(tool) {
    const toggle = tool.querySelector("[data-dm-mobile-cart-tool-toggle]");
    if (!toggle) return;

    const open = tool.classList.contains("is-open");
    const pending = open && isPending(tool);
    const code = open ? "" : appliedCodeOf(tool);
    tool.classList.toggle("is-pending", pending);

    const submitLabel = tool.querySelector('[data-dm-mobile-cart-tool-panel] button[type="submit"]')?.getAttribute("aria-label");
    if (code) toggle.setAttribute("aria-label", `Remover cupom ${code}`);
    else if (pending && submitLabel) toggle.setAttribute("aria-label", submitLabel);
    else toggle.removeAttribute("aria-label");
  }

  function setToolState(tool, open) {
    if (!tool) return;

    const toggle = tool.querySelector("[data-dm-mobile-cart-tool-toggle]");
    const panel = tool.querySelector("[data-dm-mobile-cart-tool-panel]");
    if (!toggle || !panel) return;

    tool.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    panel.toggleAttribute("inert", !open);
    syncToggle(tool);
  }

  function openTool(tool) {
    cancelShippingClose();
    const toolsRoot = tool.closest("[data-dm-mobile-cart-tools]");
    toolsRoot?.querySelectorAll("[data-dm-mobile-cart-tool]").forEach((other) => {
      if (other !== tool) setToolState(other, false);
    });
    // O que já vem no campo (CEP salvo) conta como enviado: o 1º clique fecha, não recalcula.
    const field = fieldOf(tool);
    if (field?.value.trim()) tool.dataset.submittedValue = field.value.trim();
    setToolState(tool, true);
    window.diMangiareCartOpenTool = tool.getAttribute("data-dm-mobile-cart-tool");
    field?.focus();
  }

  function closeTool(tool) {
    cancelShippingClose();
    setToolState(tool, false);
    window.diMangiareCartOpenTool = "";
  }

  function restoreOpenTool() {
    const sidebar = document.querySelector("#halo-cart-sidebar");
    if (!sidebar) return;

    sidebar.classList.remove("cart-tab-shipping");
    sidebar.querySelectorAll("[data-dm-mobile-cart-tool]").forEach((tool) => {
      setToolState(
        tool,
        tool.getAttribute("data-dm-mobile-cart-tool") === window.diMangiareCartOpenTool
      );
    });
  }

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-dm-mobile-cart-tool-toggle]");
    const tool = event.target.closest("#halo-cart-sidebar [data-dm-mobile-cart-tool]");
    if (!tool) return;
    const shippingRadio = event.target.closest(".shipping-option-radio");
    if (shippingRadio && tool.getAttribute("data-dm-mobile-cart-tool") === "shipping") {
      // A escolha é salva imediatamente; a lista fecha 1s depois da última escolha.
      // Inclui a confirmação da opção já selecionada, sem evento change.
      scheduleShippingClose(tool, 1000);
      return;
    }
    const header = event.target.closest(".dm-mobile-cart-tool__label, .dm-mobile-cart-tool__action");
    if (!toggle && tool.classList.contains("is-open") && !header && event.target !== tool) return;

    // O X (CSS: código aplicado com o campo fechado) remove o cupom.
    const appliedCode = tool.classList.contains("is-open") ? "" : appliedCodeOf(tool);
    if (appliedCode) {
      tool.querySelector("cart-discount-component")?.removeSingleDiscount(appliedCode);
      return;
    }

    if (!tool.classList.contains("is-open")) {
      openTool(tool);
      return;
    }

    if (isPending(tool)) {
      tool.dataset.submittedValue = fieldOf(tool).value.trim();
      fieldOf(tool).form?.requestSubmit();
      syncToggle(tool);
      return;
    }

    closeTool(tool);
  });

  // Sem escolha manual, confirma a opção já pré-selecionada após 2 segundos.
  document.addEventListener("shipping:options-ready", (event) => {
    const tool = event.target.closest?.('#halo-cart-sidebar [data-dm-mobile-cart-tool="shipping"]');
    if (tool?.classList.contains("is-open")) scheduleShippingClose(tool, 2000);
  });

  // Enter envia o formulário pelo próprio componente; aqui só se registra o valor enviado.
  document.addEventListener("submit", (event) => {
    const tool = event.target.closest?.("#halo-cart-sidebar [data-dm-mobile-cart-tool]");
    const field = tool && fieldOf(tool);
    if (!field) return;
    tool.dataset.submittedValue = field.value.trim();
    syncToggle(tool);
  }, true);

  document.addEventListener("input", (event) => {
    const tool = event.target.closest?.("#halo-cart-sidebar [data-dm-mobile-cart-tool]");
    if (!tool) return;
    if (tool.getAttribute("data-dm-mobile-cart-tool") === "shipping") cancelShippingClose();
    if (!event.target.value.trim()) delete tool.dataset.submittedValue;
    syncToggle(tool);
  });

  // Cupom aplicado: o campo fecha e a linha mostra o código com o X.
  document.addEventListener("discount:update", () => {
    const tool = document.querySelector('#halo-cart-sidebar [data-dm-mobile-cart-tool="discount"]');
    if (!tool) return;
    delete tool.dataset.submittedValue;
    if (tool.classList.contains("is-open") && appliedCodeOf(tool)) closeTool(tool);
    else syncToggle(tool);
  });

  document.addEventListener("cart:refresh", restoreOpenTool);
  document.addEventListener("cart-update", restoreOpenTool);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreOpenTool);
  } else {
    restoreOpenTool();
  }
})();

/* Desfazer remoção: restaura variante, quantidade, propriedades e plano de venda. */
(function initCartUndo() {
  if (window.diMangiareCartUndoInit) return;
  window.diMangiareCartUndoInit = true;

  let removedItem = null;
  let hideTimer = null;

  function getUndoNotice() {
    return document.querySelector("#halo-cart-sidebar [data-cart-undo]");
  }

  function hideUndo() {
    const notice = getUndoNotice();
    if (notice) notice.hidden = true;
    removedItem = null;
    window.clearTimeout(hideTimer);
  }

  window.diMangiareOfferCartUndo = function(item) {
    if (!item) return;

    removedItem = item;
    const notice = getUndoNotice();
    if (!notice) return;

    notice.hidden = false;
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hideUndo, 2000);
  };

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-cart-undo-button]");
    if (!button || !removedItem) return;

    event.preventDefault();
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    const restoreItem = {
      id: removedItem.variant_id || removedItem.id,
      quantity: removedItem.quantity || 1,
    };

    if (removedItem.properties && Object.keys(removedItem.properties).length) {
      restoreItem.properties = removedItem.properties;
    }

    const sellingPlanId =
      removedItem.selling_plan_allocation &&
      removedItem.selling_plan_allocation.selling_plan &&
      removedItem.selling_plan_allocation.selling_plan.id;
    if (sellingPlanId) restoreItem.selling_plan = sellingPlanId;

    try {
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";
      const addResponse = await fetch(root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: [restoreItem] }),
      });

      if (!addResponse.ok) throw new Error("Não foi possível restaurar o produto.");

      const cartResponse = await fetch(root + "cart.js", {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      const cart = await Shopify.removeOrphanCartUpsells(await cartResponse.json());

      hideUndo();
      if (typeof window.diMangiareRefreshSideCart === "function") {
        await window.diMangiareRefreshSideCart(cart);
      } else if (typeof window.updatecart === "function") {
        window.updatecart(cart);
      }
    } catch (error) {
      const notice = getUndoNotice();
      if (notice) {
        const message = notice.querySelector("span");
        if (message) message.textContent = "Não foi possível desfazer. Tente novamente.";
      }
    } finally {
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  });
})();
